import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';

export default () => getUserConfiguration().UserOptions.EnableReminders;
